module.exports = __webpack_public_path__ + "img/icon-yandexMetrica.4798e7a9.png";